import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { injectIntl } from 'react-intl';
import { Button} from 'react-bootstrap';
import { connect } from 'react-redux';
import { validateSessionConnection } from '../../actions/session';
import { runPublish } from '../../utils/xtrafunc';
import Noty from "noty";

const SERVER_MESSAGE_EMPTY_QUEUE = 'Queue is empty';
Noty.overrideDefaults({
  theme: 'bootstrap-v4',
  layout: 'center',
  closeWith: 'click',
  timeout: 4000,
  progressBar: false,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  validateSession: surl => dispatch(validateSessionConnection(surl)),
});

const mapStateToProps = state => ({
  session: state.session,
});

const PortalPublish = ({ session, validateSession, intl }) => {
  const onPublishClick = () => {
    const n = new Noty({
      timeout: 0,
      layout: 'center',
      type: 'info',
      text: intl.formatMessage({ id: 'adminPublish.publishBtnTitle' }),
      buttons: [
        Noty.button(intl.formatMessage({ id: 'adminPublish.publishBtnStart' }),
          'btn btn-success', () => {
          runSync();
            n.close();
          }),
        Noty.button(intl.formatMessage({ id: 'adminPublish.publishBtnCancel' }),
          'btn btn-error', () => {
            n.close();
          }),
      ],
    });
    n.show();
  };

  const runSync = () => {
  const surl = session ? session.get('surl') : sessionStorage.surl;
  validateSession(surl).then((res) => {
    if (res.isValid) {
      runPublish()
        .done(() => {
          new Noty({
            type: 'info',
            text: intl.formatMessage({id: 'adminPublish.publishProc.Success'}),
          }).show();
        })
        .fail((err) => {
          if (err.responseText.includes(SERVER_MESSAGE_EMPTY_QUEUE)) {
            new Noty({
              type: 'info',
              text: intl.formatMessage({id: 'adminPublish.publishProc.EmptyQueue'}),
            }).show();
          } else
          new Noty({
            type: 'error',
            text: intl.formatMessage({id: 'adminPublish.publishProc.Fail'}),
          }).show();
          console.log(err);
        })
    }});
  };

  return (
    <div className="local-admin-content__publish">
      <h1 className="page-header">{intl.formatMessage({id: 'adminPublish.publishTitle'})}</h1>
      <row>
        <label className="local-admin-content__publish-btn__label">
          {intl.formatMessage({id: 'adminPublish.publishSubTitle'})}
        </label>
        <br />
        <br />
        <Button className="local-admin-content__publish-btn" size="sm" variant="primary" onClick={onPublishClick}>
          {intl.formatMessage({ id: 'adminPublish.publishBtn' })}
        </Button>
      </row>
    </div>
  );
};

PortalPublish.propTypes = {
  dispatch: PropTypes.func,
  session: PropTypes.instanceOf(Map),
  validateSession: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(PortalPublish));



// WEBPACK FOOTER //
// ./src/js/components/PortalPublish/index.jsx